/*! @azure/msal-common v15.13.2 2025-11-19 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.13.2";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
